import type { Language } from '@/api/v1/administration/profile/update-language/update-language.types'
import type { Locale } from '@/stores/language'

const LANGUAGE_TO_LOCALE: Record<Language, Locale> = {
  PtBr: 'ptBr',
  EnUs: 'enUs',
  EsEs: 'esEs',
  FrFr: 'frFr',
  DeDe: 'deDe',
  ItIt: 'itIt',
}

// Analytics person properties must use the locale format ('ptBr') — the backend
// PostHog pipeline writes the same format, and marketing workflows branch on it.
export const languageToLocale = (language: Language): Locale =>
  LANGUAGE_TO_LOCALE[language]
